import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { useMutation } from '@apollo/client';
import { userInfoState } from 'states/CheckOutStates/atoms';
import { DASHBOARD_UPDATE_PERSONAL_DETAILS_BY_USER_ID } from 'graphql/service';
import { useAuth } from 'customHooks/useAuth';
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';

type PersonalDetailsInput = {
  fullName: string;
  address: string;
  addressLine2: string;
  city: string;
  province: string;
  postalCode: string;
  country: string;
  dateOfBirth: string;
};

export const useUpdatePersonalDetails = () => {
  const debug = false;

  const { showGlobalError, showGlobalMessage } = useGlobalAlerts();
  const userId = localStorage.getItem('userId');
  const { refreshUserInfo } = useAuth();

  useEffect(() => {
    refreshUserInfo();
  }, [refreshUserInfo]);

  const setUserInfo = useSetRecoilState(userInfoState);

  const [dashboardUpdatePersonalDetailsByUserId] = useMutation(DASHBOARD_UPDATE_PERSONAL_DETAILS_BY_USER_ID, {
    onCompleted: (data) => {
      if (debug) {
        console.log('data =');
        console.log(data);
      }
      if (data.updateUser.userId) {
        showGlobalMessage("Your personal details have been successfully changed.");

        setUserInfo((userInfo) => ({
          ...userInfo,
          fullNameInput: data.updateUser.fullName || '',
          mailAddressInput: data.updateUser.address || '',
          addressLine2Input: data.updateUser.addressLine2 || '',
          cityInput: data.updateUser.city || '',
          provinceInput: data.updateUser.province || '',
          postalCodeInput: data.updateUser.postalCode || '',
          countryInput: data.updateUser.country || '',
          dateOfBirth: data.updateUser.dateOfBirth || ''
        }));

        if (debug) {
          console.log("User data updated successfully!");
          console.log(data);
        }
      } else {
        const content = "User data update failed!";
        if (debug) {
          console.log(data);
        }
        showGlobalError(content);

      }
    },
    onError: (error) => {
      const content = error.message;

      showGlobalError(content);


      if (debug) {
        console.log(error);
      }
    },
  });

  const savePersonalDetails = (input: PersonalDetailsInput) => {
    dashboardUpdatePersonalDetailsByUserId({
      variables: {
        userId,
        input,
      },
    });
  };

  return {
    savePersonalDetails,
  };
};
